import { SmilePlus, Meh, Frown } from 'lucide-react';
import type { FC } from 'react';

interface SentimentBadgeProps {
  sentiment: string | null | undefined;
}

const CONFIG: Record<string, { icon: typeof SmilePlus; label: string; cls: string }> = {
  positive: {
    icon: SmilePlus,
    label: 'Positif',
    cls: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400',
  },
  neutral: {
    icon: Meh,
    label: 'Neutre',
    cls: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300',
  },
  negative: {
    icon: Frown,
    label: 'Négatif',
    cls: 'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-400',
  },
};

const SentimentBadge: FC<SentimentBadgeProps> = ({ sentiment }) => {
  const cfg = CONFIG[sentiment ?? ''] ?? CONFIG.neutral;
  const Icon = cfg.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${cfg.cls}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {cfg.label}
    </span>
  );
};

export default SentimentBadge;
